import { render } from "./detailed-information-chart.vue?vue&type=template&id=0bd09ed4&scoped=true"
import script from "./detailed-information-chart.vue?vue&type=script&lang=js"
export * from "./detailed-information-chart.vue?vue&type=script&lang=js"

import "./detailed-information-chart.vue?vue&type=style&index=0&id=0bd09ed4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd09ed4"]])

export default __exports__